import OBTComplete2 from "./OBTComplete2";
export default OBTComplete2;